import Vue from 'vue';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
export default Vue.extend({
  name: 'PropPanelFooter',
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  props: {
    comp: {
      type: Object,
      required: true
    }
  },
  render() {
    var _this$designer;
    const h = arguments[0];
    const footerSlot = (_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.$scopedSlots) === null || _this$designer === void 0 ? void 0 : _this$designer.propPanelFooter;
    if (footerSlot) return footerSlot({
      comp: this.comp
    });
    return h("div");
  }
});
//# sourceMappingURL=footer.js.map
